import React from "react";
import { Button, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { ActionsMenuItem } from "./ActionsMenuItem";
import { colours } from "@/utils/themeUtils";
import { ChakraFAIcon } from "@/components/ui/Icon";

export type ActionsDropdownItem = {
	icon: string;
	label: string;
	show: boolean;
	disabled: boolean;
	action: () => void;
	tooltip?: string;
	dataTestId?: string;
};

interface Props {
	title: string;
	dataTestId?: string;
	items: ActionsDropdownItem[];
}

export function ActionsMenu(props: Props): JSX.Element {
	return (
		<Menu>
			<MenuButton
				as={Button}
				title={props.title}
				alignItems={"center"}
				py={0}
				px={4}
				border={"1px solid #cdcdcd"}
				rounded={"6px"} // Hack to prevent FZLC Chakra theme in Courses microfrontend from overriding the border radius
				background={"white"}
				color={colours.navy[800]}
				_hover={{
					background: "#F3F5F9",
				}}
				_active={{
					background: "#F3F5F9",
				}}
				data-testid={props.dataTestId}
			>
				{props.title}
				<ChakraFAIcon icon="fa-chevron-down" variant="solid" color="#6B778C" boxSize={4} ml={3} />
			</MenuButton>
			<MenuList minWidth={"170px"} maxWidth={"250px"}>
				{props.items.map(
					(item) =>
						item.show && (
							<ActionsMenuItem
								key={item.label}
								icon={item.icon}
								label={item.label}
								tooltip={item.tooltip}
								onClick={item.action}
								disabled={item.disabled}
								dataTestId={item.dataTestId}
							/>
						)
				)}
			</MenuList>
		</Menu>
	);
}
